import { dayjs } from 'core-helpers';
import dayjsCustom from './dayjs';

export const timestampToDate = (timestamp: number) => {
  return new Date(timestamp * 1000);
};

export const convertDateString = (date: string) => {
  let resultDate = new Date(date);
  let result = `${resultDate.getFullYear()}/${(resultDate.getMonth() + 1).toString().padStart(2, '0')}/${resultDate.getDate().toString().padStart(2, '0')}`;

  return result;
};

export const getToday = () => {
  return dayjsCustom().format('YYYY/MM/DD');
};

export const getFormattedDay = (inputDate?: string, format?: string) => {
  return dayjsCustom(inputDate).format(format ?? 'YYYY/MM/DD');
};

export const getFirstDayOfNextMonth = (inputDate?: string, format?: string) => {
  const targetDay = dayjsCustom(inputDate);
  const firstDayNextMonth = targetDay.add(1, 'month').startOf('month');

  return firstDayNextMonth.format(format ?? 'YYYY/MM/DD');
};

export const getFirstDayOfSecondMonth = (
  inputDate?: string,
  format?: string
) => {
  const targetDay = dayjsCustom(inputDate);
  const firstDayNextMonth = targetDay.add(2, 'month').startOf('month');

  return firstDayNextMonth.format(format ?? 'YYYY/MM/DD');
};

export const getFirstDayOfThirdMonth = (
  inputDate?: string,
  format?: string
) => {
  const targetDay = dayjsCustom(inputDate);
  const firstDayThirdMonth = targetDay.add(3, 'month').startOf('month');

  return firstDayThirdMonth.format(format ?? 'YYYY/MM/DD');
};

export const getFirstDayOfCurrentMonth = (
  inputDate?: string,
  format?: string
) => {
  const targetDay = dayjs(inputDate);
  const firstDayNextMonth = targetDay.startOf('month');

  return firstDayNextMonth.format(format ?? 'YYYY/MM/DD');
};

export const getNextMonthSpecificDay = (
  day: number,
  inputDate?: string,
  format?: string
) => {
  const targetDay = dayjsCustom(inputDate);
  const nextMonthSameDay = targetDay.add(1, 'month').date(day);

  return nextMonthSameDay.format(format ?? 'YYYY/MM/DD');
};

export const getSpecificDayOfCurrentMonth = (
  day: number,
  inputDate?: string,
  format?: string
) => {
  const targetDay = dayjsCustom(inputDate);
  const specificDay = targetDay.date(day);

  return specificDay.format(format ?? 'YYYY/MM/DD');
};

export function getSpecificFutureDay(day: number, inputDate?: string): string {
  const currentDate = dayjsCustom(inputDate);

  // Try to create the date in the current month
  let targetDate = dayjsCustom(inputDate).date(
    Math.min(day, currentDate.daysInMonth())
  ); // Clamp to avoid rollover

  if (targetDate.isBefore(currentDate, 'day')) {
    // Move to next month
    const nextMonth = currentDate.add(1, 'month');
    targetDate = nextMonth.date(
      Math.min(day, nextMonth.daysInMonth()) // Clamp again for next month
    );
  }

  return targetDate.format('YYYY/MM/DD');
}

export const getDateWithOffset = (
  offset: number,
  inputDate?: string,
  format?: string
) => {
  const targetDay = dayjsCustom(inputDate);
  const futureDate = targetDay.add(offset, 'day');

  return futureDate.format(format ?? 'YYYY/MM/DD');
};

export const getCurrentTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export const COMPARE_TYPES = {
  IS_BEFORE: 'is-before',
  IS_SAME: 'is-same',
  IS_AFTER: 'is-after',
  IS_SAME_OR_BEFORE: 'is-same-or-before',
  IS_SAME_OR_AFTER: 'is-same-or-after',
  IS_NOT_SAME: 'is-not-same'
};

export const compareDate = (a: any, b: any, type: string) => {
  const dateA = dayjs(a);
  const dateB = dayjs(b);

  if (!dateA.isValid() || !dateB.isValid()) {
    return false;
  }

  switch (type) {
    case COMPARE_TYPES.IS_BEFORE:
      return dateA.isBefore(dateB);
    case COMPARE_TYPES.IS_AFTER:
      return dateA.isAfter(dateB);
    case COMPARE_TYPES.IS_SAME:
      return dateA.isSame(dateB);
    case COMPARE_TYPES.IS_SAME_OR_BEFORE:
      return dateA.isBefore(dateB) || dateA.isSame(dateB);
    case COMPARE_TYPES.IS_SAME_OR_AFTER:
      return dateA.isAfter(dateB) || dateA.isSame(dateB);
    case COMPARE_TYPES.IS_NOT_SAME:
      return !dateA.isSame(dateB);
    default:
      return false;
  }
};
